import React from 'react';
import CompanyHotel from '@app/model/company_hotel/CompanyHotel';
import AlertExecution from '@app/model/alert/AlertExecution';
import CompetitorsPriceRateNotificationRowFragment
	from '@app/site/secured/rateshopper/rates/alert-execution/fragment/competitors-price-rate/CompetitorsPriceRateNotificationRowFragment';
import CompetitorsPriceRateAlertExecutionNotificationOutput
	from '@app/model/alert/output/CompetitorsPriceRateAlertExecutionNotificationOutput';


const CompetitorsPriceRateNotificationsFragment: React.FunctionComponent<{
	companyHotel: CompanyHotel,
	alertExecution: AlertExecution,
	notificationOutputs: CompetitorsPriceRateAlertExecutionNotificationOutput[],
	isInDrawer?: boolean
}> = ({ companyHotel, alertExecution, notificationOutputs, isInDrawer = false }) => {

	const days = alertExecution.alertOutput.alert.timeframe.days;

	return <section className={`mt-8 ${isInDrawer ? 'bg-gray-50' : 'bg-white'} rounded-xl border border-gray-200 p-6 shadow-sm sm:p-8`}>
		<div>
			<div className="flex items-center justify-between">
				<h2 className="text-base font-semibold leading-6 text-gray-950">
					Next {days} {days === 1 ? 'day' : 'days'}
				</h2>
			</div>
			<div className="mt-5 flow-root">
				<div className="overflow-x-auto">
					<div className="inline-block min-w-full align-middle">
						<table className="min-w-full divide-y divide-gray-300 text-gray-500">
							<thead>
							<tr>
								<th scope="col"
									className="whitespace-normal py-3 pl-0 pr-3 text-left text-sm font-semibold text-gray-950">Competitor
								</th>
								<th scope="col"
									className="whitespace-nowrap px-2 py-3 text-left text-sm font-semibold text-gray-950">Room
								</th>
								<th scope="col"
									className="whitespace-nowrap px-2 py-3 text-left text-sm font-semibold text-gray-950">Change
								</th>
								<th scope="col"
									className="whitespace-normal px-2 py-3 text-left text-sm font-semibold text-gray-950">Room Found
								</th>
								<th scope="col"
									className="relative whitespace-nowrap py-3 pl-3 pr-0 text-left text-sm font-semibold text-gray-950">
								</th>
							</tr>
							</thead>
							{notificationOutputs.map(notificationOutput => <CompetitorsPriceRateNotificationRowFragment
								companyHotel={companyHotel} alertExecution={alertExecution} key={notificationOutput.notificationId}
								notificationOutput={notificationOutput} />)}
						</table>
					</div>
				</div>
			</div>
		</div>
	</section>;
};

export default CompetitorsPriceRateNotificationsFragment;
